var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstallZeroTyping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4C0 1.79087 1.74609 0 3.9 0H9.32304C10.3574 0 11.3494 0.421427 12.0808 1.17157L13.5385 2.66667H22.1C24.254 2.66667 26 4.45753 26 6.66667V20C26 22.2092 24.254 24 22.1 24H3.9C1.74609 24 0 22.2092 0 20V4ZM8.23633 14.7743L12.1363 18.3299C12.6288 18.7789 13.3712 18.7789 13.8637 18.3299L17.7637 14.7743C18.3002 14.2851 18.3486 13.4423 17.8716 12.892C17.3946 12.3416 16.5729 12.292 16.0363 12.7812L14.3 14.3643V9.33333C14.3 8.59696 13.718 8 13 8C12.282 8 11.7 8.59695 11.7 9.33333V14.3643L9.96367 12.7812C9.42705 12.292 8.60536 12.3416 8.12837 12.892C7.65137 13.4424 7.6997 14.2851 8.23633 14.7743Z",
    fill: "#3AB1F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallZeroTyping);
export default __webpack_public_path__ + "static/media/Install Zero Typing.71235a1045b0e0466f566c3f26e21bd2.svg";
export { ForwardRef as ReactComponent };